import mergeWith from 'lodash/mergeWith';
import { initialState } from './selectors';
import { ENTITIES_RECEIVE } from './actions';

export default (state = initialState, { type, payload }) => {
  if (type === ENTITIES_RECEIVE) {
    return mergeWith({}, state, payload, (objValue, srcValue) => {
      if (Array.isArray(srcValue)) {
        return srcValue;
      }
      return undefined;
    });
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/entities/reducer.js